/* unplugin-vue-components disabled */import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_GlobalFooter = _resolveComponent("GlobalFooter");
  return _openBlock(), _createBlock(_component_GlobalFooter, {
    class: "i-copyright",
    copyright: $data.copyright
  }, null, 8 /* PROPS */, ["copyright"]);
}